import React from "react";
import { StyledMessage } from "./styles";

export default function FriendNoPosts() {
  return <StyledMessage>Este usuario aún no tiene publicaciones</StyledMessage>;
}
